import { gql } from "@apollo/client";

export const GET_TEAM_MEMBERS = gql`
	query TeamMembers($isPreview: Boolean = false) {
		teamCollection(preview: $isPreview) {
			items {
				sys {
					id
				}
				name
				postNominals
				jobTitle
				qualifications
				biography {
					json
				}
				portrait {
					url
				}
				priority
			}
		}
	}
`;

export const GET_TEAM_MEMBER = gql`
	query TeamMember($teamMemberId: String!) {
		team(id: $teamMemberId) {
			name
			postNominals
			jobTitle
			qualifications
			biography {
				json
			}
			portrait {
				url
			}
		}
	}
`;
